// WebsiteBody.js
import React from 'react';
import Head from "./Head.jsx"
import Head1 from "./Head1.jsx"
import Head2 from "./Head2.jsx"

const WebsiteBody = () => {
  return (
    <div>
<Head/>
<hr />
<h1>Latest News</h1>
<Head1/>

</div>
);
};

export default WebsiteBody;
